import Colours from './Colours';


export default {
    TRANSPARENT: Colours.TRANSPARENT, // for use with ALL variants
    COCONUT: Colours.COCONUT, // for use with DEFAULT & MINIMAL variants only
    BLUEBERRY_LIGHTEST: Colours.BLUEBERRY_LIGHTEST, // for use with BLUEBERRY variant only
};
